import React, { useEffect, useState } from "react"
import styles from "@/components/Remedy/components/HeroBlockSection/components/HeroBlockTextUnder/HeroBlockTextUnder.module.scss"
import { Typography } from "@kohler-dsm-library/kohler-core"

export const HeroBlockTextUnder = () => {
  const [opacity, setOpacity] = useState(1)

  const handleScrollOpacity = () => {
    if (
      window.scrollY > window.innerHeight * 0.8 &&
      window.scrollY < 1.7 * window.innerHeight
    ) {
      setOpacity(1)
    } else {
      setOpacity(0)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScrollOpacity)

    return () => {
      window.removeEventListener("scroll", handleScrollOpacity)
    }
  }, [])

  return (
    <div
      className={styles["hero-block-text-under"]}
      style={{ opacity: opacity }}
    >
      <div className={styles["__content"]}>
        <div className={styles["__text-content"]}>
          <Typography
            className={styles["__title"]}
            mod="charcoal"
            component="h1"
            /* component="span" */
            size="h2"
          >
            Experience Wellness at 39°F
          </Typography>
        </div>
      </div>
    </div>
  )
}
